/**
 * Routes where a past-due customer could place or add to an order — the
 * pages the past-due modal re-arms on after "Continue browsing".
 *
 * ⚠ Exact routes, never startsWith('/order'): that also matches
 * /orders/:order_id, so reading a past order brought the modal back.
 */
export function isOrderingRoute(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, '') || '/';
  return p === '/order' || p === '/cart' || /^\/orders\/[^/]+\/change$/.test(p);
}
